import { idGenerator } from '@/services'

export interface ProsumerDeclarationState {
  requestId: string
}

export const InitialState: ProsumerDeclarationState = {
  requestId: idGenerator.getNewWebReference()
}
